import { useMutation } from '@apollo/client'
import { useToast } from '@canyon/ui/useToast'
import { fbq } from '@canyon/utils'
import { useRouter } from 'next/navigation'

import {
  SubscriptionPlanEnum,
  UseBillingPlan_BillingPortalUrlDocument,
  UseBillingPlan_SubscriptionSessionCreateDocument,
} from '@gql/graphql'

import { useCurrentUser } from '@/hooks/useCurrentUser'

interface ICreateSubscription {
  coupon?: string
  isCreatedFromOnboarding?: boolean
  plan: SubscriptionPlanEnum
}

export const useBillingPlan = () => {
  const router = useRouter()
  const { errorToast } = useToast()
  const { user } = useCurrentUser()

  const [createSubscriptionSession] = useMutation(UseBillingPlan_SubscriptionSessionCreateDocument)

  const handleCreateSubscription = async ({
    coupon,
    isCreatedFromOnboarding,
    plan,
  }: ICreateSubscription) => {
    const { data, errors } = await createSubscriptionSession({
      variables: {
        coupon,
        isCreatedFromOnboarding,
        plan,
      },
    })

    const url = data?.subscriptionsSessionCreate

    if (!url || errors?.length) {
      errorToast()
      return
    }

    fbq.eventStandard('InitiateCheckout')
    router.push(url)
  }

  const [billingPortalUrl] = useMutation(UseBillingPlan_BillingPortalUrlDocument, {})

  const handleManageSubscription = async () => {
    const { data } = await billingPortalUrl()

    const url = data?.billingPortalUrl
    window.open(url, '_blank')?.focus()
  }

  return {
    createSubscription: ({ coupon, isCreatedFromOnboarding, plan }: ICreateSubscription) =>
      handleCreateSubscription({ coupon, isCreatedFromOnboarding, plan }),
    manageSubscription: handleManageSubscription,
  }
}
